import {
  Card,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const FieldItem = ({ field, dragHandleProps, onEdit, onDelete }) => {
  return (
    <Card sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <div {...dragHandleProps}>
          <DragIndicatorIcon sx={{ cursor: "grab" }} />
        </div>

        <Stack flex={1}>
          <Typography fontWeight={600}>{field.label}</Typography>
          <Typography variant="body2" color="text.secondary">
            Type : {field.type} • {field.required ? "Obligatoire" : "Optionnel"}
          </Typography>
        </Stack>

        <IconButton onClick={onEdit}>
          <EditIcon />
        </IconButton>

        <IconButton color="error" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </Stack>
    </Card>
  );
};

export default FieldItem;
